import { ICuttingBaseMaterial } from '../cutting/cutting-base-material.model';
import { MaterialsCompareType } from '../cutting/cutting-material.model';
import { OutlineEditorOptions } from './outline-editor-options.model';

export class CuttingSettings {
  sendDateOfIssueChangeNotify = true;
  framePageUrl = '';
  howToOrderUrl = '';
  materialBaseIdForSpecification: number;
  defaultStampTemplate: boolean;
  checkPanelConstrainsFromModels = false;
  defaultDiscountGroupId: number | null = null;
  defaultManagerId: number | null = null;
  useMatSizesFromMatBase = false;
  useFactoryOrderNumber = false;
  orderTableFields: OrderListTableField[] = [];
  cuttingResultFileType: CuttingResultFileTypeEnum = CuttingResultFileTypeEnum.Zbprj;
  orderPrefix = '#';
  enabledForClientCuttingEngines: CuttingEngine[] = [];
  showCuttingMaps = true;
  checkHolesFromModels = false;
  customGrooves: CustomGrooves;
  estimateSettings: EstimateSettings;
  invoiceServiceInfo: InvoiceServiceInfo;
  unlicensedModelsAccess: UnlicensedModelsAccess;
  specificationSettings: SpecificationSettings;
  smsServiceSettings: SMSService;
  clientReginstering: ClientReginstering;
  outlineEditorOptions: OutlineEditorOptions = new OutlineEditorOptions();
  makeDrawingsSettings: MakeDrawingsSettings;
  cutoutSettings: CutoutSettings;
  questions: CuttingQuestionSettings;
  panels: PanelSettings = new PanelSettings();
  butts: ButtsSettings = new ButtsSettings();
  defaultMatSizes: DefaultMatSizes = new DefaultMatSizes();
  cuttingProductSettings: CuttingProductSettings = new CuttingProductSettings();
  defaultCuttingEngine: CuttingEngine = CuttingEngine.OldEngine;
  cuttingOrderPaymentSettings: CuttingOrderPaymentSettings = new CuttingOrderPaymentSettings();
  cleaning: CleaningSettings = new CleaningSettings();
  cudModelSettings: CadModelSettings = new CadModelSettings();
  bannerSettings: BannerSettings = new BannerSettings();
  postforming: MatBaseGroupPostforming[] = [];
  customEmailSender: IEmailSender;
  delivery: OrderDelivery;
  showDiscountPercent = false;
  disableDownloadingModelForClient = false;
  controlProgramsSettings: ControlProgramsSettings;
  allowClientsChooseManager = true;
  showSignHandPanelsOnCauttingCards = false;
  enabledUserProperties: string[] = [];
  showQuantityInStock = false;
  useCuttingEngineFromSettings = false;
  makeSpecification1CXml = true;
  ignoreAllowanceWnenRecalculatingPanelSize = false;
  countertopSettings: CountertopSettings;
  showStandardMaterialSizes = false;
  bazisPlacementSettings: BazisPlacementSettings;
  isMaintenanceInProgress: boolean;
}

export interface ControlProgramsSettings {
  autogenerate: boolean;
  autogenerateAfterOrderStatusId: number;
  panelDrawingsParamName: string;
}

export interface OrderDelivery {
  courier: boolean;
  pointOfIssue: boolean;
}

export interface IEmailSender {
  enabled: boolean;
  smtpServer: string;
  smtpPort: number;
  email: string;
  password: string;
  senderName: string;
}

export class CleaningSettings {
  deleteOrderFilesAfter: number;
  deleteOrderAfter: number;
  moveOrderToArchiveAfter: number;
}

export enum CuttingEngine {
  OldEngine,
  NewEngine,
  TightCut,
  FromSettings,
}

export class CuttingOrderPaymentSettings {
  enable: boolean;
  linkToCart: string;
}

export class MatBaseGroupPostforming {
  inMatBaseId: number;
  editableWidth: boolean;
  postformingSide: PostformingSideEnum = PostformingSideEnum.Bottom;
}

export class PanelSettings {
  minHeight = 50;
  minWidth = 50;

  minHeightWithCornerAndCutout = 50;
  minWidthWithCornerAndCutout = 50;

  maxHeightWithCornerAndCutout = 0;
  maxWidthWithCornerAndCutout = 0;

  minHeightWithButt = 150;
  minWidthWithButt = 150;

  minHeightWithHole = 200;
  minWidthWithHole = 200;

  maxHeightWithHole = 0;
  maxWidthWithHole = 0;

  maxNumberPrecision = 1;
}

export class DefaultMatSizes {
  linear: MatSize = new MatSize(3050, 600);
  plate: MatSize = new MatSize(2440, 1830);
}

export class CuttingProductSettings {
  addMaterialsFromMatBase: boolean;
  disableDeletingProductElements: boolean;
  useOverallDimensionsForProduct: boolean;
}

export class CadModelSettings {
  maxSignLength: number;
}

export class MatSize {
  constructor(_height: number, _width: number) {
    this.height = _height;
    this.width = _width;
  }

  height = 0;
  width = 0;
}

export class ButtsSettings {
  checkButtWidth = false;
  minDifferenceBetweenButtWidthAndPanelThickness = 3;
  maxDifferenceBetweenButtWidthAndPanelThickness = 0;
}

export class OrderListTableField {
  name = '';
  visible = true;
}

export interface CuttingQuestionSettings {
  notificationInterval: number;
}

export interface ClientReginstering {
  requiredPhoneNumber: boolean;
  requiredPatronymic: boolean;
  requiredINN: boolean;
  clientAgreement: ClientAgreement;
  confirmMode: ClientConfirmModeEnum;
  availableClientType: AvailableClientType;
  notificationToEmail: boolean;
  emailForNotification: string;
}

export enum AvailableClientType {
  All,
  Individual,
  Entity,
}

export class ClientAgreement {
  date: Date;
  lastChangeMessage: string;
  contractUrl: string;
}

export interface SMSService {
  senderName: string;
  login: string;
  password: string;
  enable: boolean;
  useCyrillic: boolean;
  server: string;
}

export class EstimateSettings {
  roundOperations: boolean; // Округлять кол-во операций при расчете
  roundMaterials: boolean; // Округлять кол-во материала при расчете
  addFastenersToEstimate: boolean; // учитывать присадку в смете
  groupMaterialsExcludeCuttingInfo: number[] = [];
  showItemsPriceBeforeVerified: boolean;
  showMaterialsPrice = false;
  materialsCompareType: MaterialsCompareType = MaterialsCompareType.NameAndArticle;
  countPrecision = 3;
  canChangeEstimateInPublicApiForVerified: boolean;
  checkClientModelFurniture: boolean;
  readClientModelAssembly: boolean;
  readCosts: boolean;
}

export interface InvoiceServiceInfo {
  showOnlyMainWork: boolean;
  nameMainWork: string;
  footherImageName: string;
}

export interface UnlicensedModelsAccess {
  enabled: boolean;
  nameInEstimate: string;
  priceInEstimate: number;
  articleInEstimate: string;
}

export interface SpecificationSettings {
  hideItemWithNullCosts: boolean;
  singleEstimateList: boolean;
  showTax: boolean;
}

export interface CustomGrooves {
  inPlate: boolean;
  inSide: boolean;
  rabbet: boolean;
  chamfer: boolean;
  fillet: boolean;
  chamfer2: boolean;
}

export class MakeDrawingsSettings {
  createDrawingsForPanels: CreateDrawingsForPanelsEnum = CreateDrawingsForPanelsEnum.AllPanels;
}

export interface CountertopSettings {
  linesClampJoints: ClampJoint[];
}

export interface ClampJoint {
  interval: number;
  workJointLength: number;
  jointLength: number;
  type: ClampJointTypeEnum;
  l: number;
  l2: number;
  h: number;
  b: number;
  d: number;
  additionalMaterials: ClampJointAdditionalMaterial[];
  minMaterialThickness: number;
  maxMaterialThickness: number;
  edgeOffset: number;
  countSettings: ClampJointCountSettings[];
  count: number;
}

export interface ClampJointAdditionalMaterial extends ICuttingBaseMaterial {
  count: number;
}

export interface ClampJointCountSettings {
  count: number;
  minJointLength: number;
  maxJointLength: number;
}

export class BazisPlacementSettings {
  estimatePlacementSettings: EstimatePlacementSettings;
}

export class BannerSettings {
  showBanner: boolean;
  fileName: string;
  key: string;
  redirectLink: string;
}

export class EstimatePlacementSettings {
  roundOperations: boolean;
  roundMaterials: boolean;
  materialsCompareType: MaterialsCompareType = MaterialsCompareType.NameAndArticle;
  roundingPrice: boolean;
  numberOfSimbolsAfterComma: number;
  numberOfSimbolsBeforeComma: number;
  roundingOfThePrice: RoundingOfThePrice = RoundingOfThePrice.RoundingToTheNearestWhole;
}

export class CuttingOrderSettings {
  defaultManagerId: number | null = null;
  cleaning: CleaningSettings | null = null;
  showCuttingMaps: boolean | null = null;
  disableDownloadingModelForClient: boolean | null = null;
  allowClientsChooseManager: boolean | null = null;
  useCuttingEngineFromSettings: boolean | null = null;
  showStandardMaterialSizes: boolean | null = null;
  enabledForClientCuttingEngines: CuttingEngine[] = [];
}

export class CuttingLinksSettings {
  framePageUrl: string;
  howToOrderUrl: string;
}

export class PrepareForFactorySettings {
  useFactoryOrderNumber: boolean;
  showSignHandPanelsOnCauttingCards: boolean;
  cuttingResultFileType: CuttingResultFileTypeEnum;
  makeDrawingsSettings: MakeDrawingsSettings;
  materialBaseIdForSpecification: number;
  makeSpecification1CXml: boolean;
  defaultStampTemplate: boolean;
}

export enum RoundingOfThePrice {
  RoundingToTheNearestWhole,
  RoundingAfterTheDecimalPoint,
  RoundingBeforeTheDecimalPoint,
}

export enum CuttingResultFileTypeEnum {
  Zbprj,
  B3d,
}

export enum ClientConfirmModeEnum {
  None,
  Email,
  Sms,
}

export enum PostformingSideEnum {
  None,
  TopAndBottom,
  Bottom,
}

export enum CreateDrawingsForPanelsEnum {
  AllPanels,
  PanelsWithAdditionalProcessingAndBanding,
  PanelsWithAdditionalProcessing,
  PanelsWithPropertyUseInDocs,
}

export enum ClampJointTypeEnum {
  Type1,
  Type2,
}

export class CutoutSettings {
  disabledParametricalCutout: boolean;
}
